import client from '../client';

const DOCUMENTS = {
  deleteDocument(documentId) {
    return client.delete(`/documents/${documentId}`)
  },
}

export default DOCUMENTS;
